/// <amd-module name="Build/Common/Library/Array" />
/**
* @param arrayA 
* @param arrayB 
* @return arrayA - arrayB
*/
export type NumberOrString = string | number;
const emptyString = "";
export function subtract<NumberOrString>(arrayA: NumberOrString[], arrayB: NumberOrString[]) {
    arrayA = arrayA || [];
    arrayB = arrayB || [];
    if (([] as any).includes) {
        return arrayA.filter(x => !(arrayB as any).includes(x));
    }
    else {
        // why? because we still support IE11, includes isn't supported there!
        let arrayBMap: { [key: string]: boolean } = {};
        let result: NumberOrString[] = [];
        for (let index = 0; index < arrayB.length; index++) {
            const value = (arrayB[index] || emptyString) + emptyString;
            arrayBMap[value] = true;
        }

        for (let index = 0; index < arrayA.length; index++) {
            const value = (arrayA[index] || emptyString) + emptyString;
            if (!arrayBMap[value]) {
                result.push(arrayA[index]);
            }
        }

        return result;
    }
}

export function intersect<NumberOrString>(arrayA: NumberOrString[], arrayB: NumberOrString[]) {
    arrayA = arrayA || [];
    arrayB = arrayB || [];
    return arrayA.filter(value => arrayB.indexOf(value) !== -1);
}
